import { FormValues } from "@/schema/console/assessments/create/FormValues";
import { QuestionCircleRegular } from "@fluentui/react-icons";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface QuestionCountProps {
  categoryIndex: number;
  subCategoryIndex: number;
}

function QuestionCount({
  categoryIndex,
  subCategoryIndex,
}: QuestionCountProps) {
  const { t } = useTranslation();
  const { control } = useFormContext<FormValues>();

  const questions = useWatch({
    control,
    name: `categories.${categoryIndex}.subcategories.${subCategoryIndex}.questions`,
  });
  const questionCount = questions.length;

  return (
    <div>
      <QuestionCircleRegular fontSize={20} className="mr-2" />
      {questionCount > 1
        ? `${questionCount} ${t("questions")}`
        : `${questionCount} ${t("question")}`}
    </div>
  );
}

export default QuestionCount;
